import "./assests/sass/style.scss";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes/Router";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Router />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
